import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';
import { Dialog } from '@reach/dialog';
import ModalFAQs from '../../components/ModalFAQs';

import BackButton from '../../components/BackButton';
import Button from '../../components/Button';
// import Disclaimer from '../../components/Disclaimer';
import RadioGroup from '../../components/RadioGroup';
import StackForm from '../../components/StackForm';
import Title from '../../components/Title';
import OfferOption from '../../components/OfferOption';
import { getNumberWithDots } from '../../helpers';
import { useGlobalData } from '../../../store';
// import { NO_TIENE_CUENTA_MESSAGE } from '../../config';
import { nextStep_step2, loginModal } from '../../analytics';

const Offers = props => {
  const [modal, setModal] = useState(false);

  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const { setGlobalData, globalData } = useGlobalData();

  const isPersonalBank = globalData?.tipoPaquete === 'P' || false;

  const onSubmit = data => {
    document.querySelector('.progress-indicator').style.width = '100%';
    action(data);

    if (window.openModal) {
      loginModal();
      window.openModal('prestamo_preaprobado');
    } else {
      console.error('Falta la ventana modal de Inicio de Sesión.');
    }
  };

  // const noTieneCuenta = state?.data?.tipo_cuenta?.includes('tipo_cuenta-no') || false;
  // const noTieneCuenta = false; // NOTE: Asumimos que tiene cuenta

  const renderOffers = () => {
    // if (noTieneCuenta) return <Disclaimer message={NO_TIENE_CUENTA_MESSAGE} />;

    const response = state?.data?.response;

    const { tasas_prestamos_personales, solicitud_original } = response;

    const monedaSolicitada = solicitud_original?.moneda; // URGP || US.D
    let monedaSimbolo;

    switch (monedaSolicitada) {
      case 'URGP':
        monedaSimbolo = '$ ';
        break;
      case 'US.D':
        monedaSimbolo = 'U$S ';
        break;
      default:
        monedaSimbolo = '';
        break;
    }

    let personalOptions = [];

    tasas_prestamos_personales.forEach((tasa, i) => {
      personalOptions.push({
        value: tasa.plazo,
        id: 'option-personal-' + i,
        component: (
          <OfferOption
            installments={tasa.plazo}
            price={monedaSimbolo + getNumberWithDots(tasa.monto_cuota)}
            total={monedaSimbolo + getNumberWithDots(tasa.monto_total)}
            rate={tasa.interes + '%'}
            isPersonalBank={isPersonalBank}
          />
        ),
      });
    });

    return (
      <>
        {tasas_prestamos_personales?.length > 0 && (
          <div>
            <div className="options-subtitle">Préstamo amortizable</div>

            <p className="options-more">
              Ver{' '}
              <button type="button" onClick={() => setModal(true)}>
                más información
              </button>{' '}
              de este producto
            </p>

            <RadioGroup
              type="card"
              name="plazo"
              isPersonalBank={isPersonalBank}
              options={personalOptions}
              register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
              error={errors.plazo}
              onChange={e => {
                const plazo = e.target.value;
                action({ plazo });
                setGlobalData({ plazo });
              }}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        {/* {noTieneCuenta
            ? 'Para terminar elegí la mejor oferta para ti.'
          : 'Ups, no sos cliente. Seguí alguno de estos pasos.'} */}
        <Title>Para terminar elegí la mejor oferta para ti.</Title>

        {renderOffers()}
      </div>

      <div className="form-actions">
        <Button block type="submit" id="pram_confirmar_3" onClick={() => nextStep_step2()}>
          lo quiero ya
        </Button>

        <BackButton />
      </div>

      <Dialog isOpen={modal} onDismiss={() => setModal(false)} aria-label="Información adicional">
        <ModalFAQs onDismiss={() => setModal(false)} defaultTab={0} />
      </Dialog>

      <style jsx global>{`
        .options-subtitle {
          font-weight: bold;
          font-size: 18px;
          color: #56504c;
          margin-bottom: 0;
        }

        .options-subtitle + :global(.banner) {
          margin-top: 10px;
        }

        .options-more {
          font-size: 15px;
          color: #757575;
          margin-bottom: 14px;
          margin-top: 0;
        }

        .options-more button {
          font: inherit;
          padding: 0;
          border: 0;
          background: transparent;
          cursor: pointer;
          color: #106eb0;
          text-decoration: none;
        }

        .options-more button:hover {
          text-decoration: underline;
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Offers);
